import { Megaphone } from 'lucide-react';
import type { CTABlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const ctaConfig: BlockTypeConfig<CTABlock> = {
  type: 'cta',
  label: 'Call to Action',
  description: 'Prominent call-to-action section with button',
  icon: Megaphone,
  category: 'interactive',
  createDefault: () => ({
    title: 'Ready to get started?',
    buttonText: 'Get started',
    buttonUrl: '',
    alignment: 'center',
    backgroundStyle: 'light',
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.alignment',
      label: 'Align',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    {
      kind: 'select',
      path: 'data.backgroundStyle',
      label: 'Background',
      options: [
        { value: 'light', label: 'Light' },
        { value: 'dark', label: 'Dark' },
        { value: 'primary', label: 'Primary' },
        { value: 'gradient', label: 'Gradient' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  variants: [
    {
      id: 'default',
      label: 'Banner',
      thumbnail: '/admin/page-editor/variants/cta-default.svg',
      apply: (d) => ({ ...d, variant: 'default' }),
    },
    {
      id: 'diagonal',
      label: 'Diagonal split',
      thumbnail: '/admin/page-editor/variants/cta-diagonal.svg',
      apply: (d) => ({ ...d, variant: 'diagonal', backgroundStyle: 'gradient' }),
    },
    {
      id: 'centered-card',
      label: 'Centered card',
      thumbnail: '/admin/page-editor/variants/cta-centered-card.svg',
      apply: (d) => ({ ...d, variant: 'centered-card', alignment: 'center' }),
    },
  ],
  sheet: [
    { kind: 'text', path: 'data.subtitle', label: 'Subtitle' },
    {
      kind: 'select',
      path: 'data.buttonStyle',
      label: 'Button style',
      options: [
        { value: 'primary', label: 'Primary' },
        { value: 'secondary', label: 'Secondary' },
        { value: 'outline', label: 'Outline' },
      ],
    },
    { kind: 'link', path: 'data.buttonUrl', label: 'Button URL' },
  ],
};
